import React from 'react';
const stats = [['500+', 'Teachers & Tutors'], ['1 + 5', 'Box Set & Bonuses'], ['4.9/5', 'Average rating'], ['Worldwide', 'Trusted globally']];
const notes = [['“I stopped spending my Sundays planning. My students (both teens and adults) love the visual layouts.”', 'Sarah M.', 'Italian Language Teacher'], ['“Whether I’m teaching a private 1-on-1 or a large group, this is my go-to resource. Truly premium.”', 'Marco B.', 'Private Tutor & Academic Instructor'], ['“No more hours searching for quality materials. Everything is logically structured and ready to print.”', 'Elena T.', 'Professional Italian Instructor']];
export function ProofSection() {
  return <section className="bg-[#0A0A0A] px-5 pb-16" data-id="element-183" data-mp="3nqwl2n820et0">
      <div className="mx-auto max-w-6xl" data-id="element-184" data-mp="3sqrb6ok090d0">
        <div className="grid grid-cols-2 border border-[#d4af37]/25 bg-[#16161F] sm:grid-cols-4" data-id="element-185" data-mp="3ss2ekn9jg63l">
          {stats.map(([value, label]) => <div key={label} className="border-b border-r border-[#d4af37]/15 px-4 py-6 text-center last:border-r-0 sm:border-b-0" data-id="element-186" data-mp="15ni47wabcxqf">
              <p className="font-display text-4xl font-bold uppercase text-[#d4af37] sm:text-5xl" data-id="element-187" data-mp="10qhxdj5n3qy9">
                {value}
              </p>
              <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-[#B0B0C0]" data-id="element-188" data-mp="ro8mutadfxkv">
                {label}
              </p>
            </div>)}
        </div>
        <div className="mt-10 grid gap-4 md:grid-cols-3" data-id="element-189" data-mp="1jewkhvcu6kts">
          {notes.map(([quote, name, role]) => <figure key={name} className="flex flex-col border border-[#E5E5EA] bg-white p-6" data-id="element-190" data-mp="1eny5cz3l3ss4">
              <div className="mb-4 text-[#d4af37]" aria-label="5 out of 5 stars" data-id="element-191" data-mp="1alteu98fnc9p">
                ★★★★★
              </div>
              <blockquote className="flex-1 text-sm font-medium italic leading-relaxed text-[#0A0A0A]" data-id="element-192" data-mp="275sduwwxxo35">
                {quote}
              </blockquote>
              <figcaption className="mt-5 border-t border-[#E5E5EA] pt-4 text-sm font-bold text-[#0A0A0A]" data-id="element-193" data-mp="fyqviigo17m">
                {name}
                <span className="ml-2 text-xs font-medium text-[#5A5A66]" data-id="element-194" data-mp="5es1n36d5e43">
                  {role}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}